export const USER_ROLES = Object.freeze({
  DENTIST: "DENTIST",
  RECEPTIONIST: "RECEPTIONIST",
  RADIOGRAPHER: "RADIOGRAPHER",
  LEAD_RADIOGRAPHER: "LEAD_RADIOGRAPHER",
  RADIOLOGIST: "RADIOLOGIST"
});
